import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  ChangeDetectionStrategy,
  DOCUMENT,
  HostListener,
  inject,
  PLATFORM_ID,
  signal,
  WritableSignal,
} from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

@Component({
  selector: "audio-theme-switcher",
  templateUrl: "./theme-switcher.component.html",
  styleUrls: ["./theme-switcher.component.sass"],
  imports: [FaIconComponent],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitcherComponent {
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  theme: WritableSignal<"dark" | "light"> = signal("light");

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.setLightTheme();

      // if (
      //   window.matchMedia &&
      //   window.matchMedia("(prefers-color-scheme: dark)").matches
      // ) {
      //   this.setDarkTheme();
      // } else {
      //   this.setLightTheme();
      // }
      // window
      //   .matchMedia("(prefers-color-scheme: dark)")
      //   .addEventListener("change", (event) => {
      //     this.theme.set(event.matches ? "dark" : "light");
      //     console.log({ theme: this.theme });
      //   });
    }
  }

  @HostListener("click", ["$event"])
  switchTheme($event: Event): void {
    if (
      !(
        $event instanceof MouseEvent ||
        ($event instanceof KeyboardEvent && $event.key === "Enter")
      )
    ) {
      $event.preventDefault();
      return;
    }

    $event.stopPropagation();

    switch (this.theme()) {
      case "dark":
        this.setLightTheme();
        break;
      case "light":
        this.setDarkTheme();
        break;
    }
  }

  setLightTheme(): void {
    this.theme.set("light");
    this.document.body.classList.add("light");
    this.document.body.classList.remove("dark");
  }

  setDarkTheme(): void {
    this.theme.set("dark");
    this.document.body.classList.add("dark");
    this.document.body.classList.remove("light");
  }
}
